import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ChecklistSection } from './components/ChecklistSection';
import { CostSection } from './components/CostSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-cream text-ink antialiased selection:bg-gold selection:text-field-deep" data-id="element-0" data-mp="3ihv0wb3a2fha">
      <MetaPixel data-id="element-1" data-mp="3rbr9en3irte8" />
      <main data-id="element-2" data-mp="3rdaqgfx028h2">
        <Hero data-id="element-3" data-mp="3rdkg22e4udm8" />
        <SocialProof data-id="element-4" data-mp="3rd1all5o5hp3" />
        <Testimonials data-id="element-5" data-mp="3relw6la09qat" />
        <ProblemSection data-id="element-6" data-mp="6hqffdy0fe4" />
        <ModulesSection data-id="element-7" data-mp="4wyzymxdckh" />
        <ChecklistSection data-id="element-8" data-mp="56m9egl55mh" />
        <BonusSection data-id="element-9" data-mp="2zl3bdjx5744s" />
        <UrgencySection data-id="element-10" data-mp="2zllijblcf2rh" />
        <PricingSection data-id="element-11" data-mp="2zmenc70qri6z" />
        <MoreResults data-id="element-12" data-mp="2zn6b4vo3kbmp" />
        <GuaranteeSection data-id="element-13" data-mp="33mowfsjtyoq2" />
        <FAQ data-id="element-14" data-mp="33lx02fiesmyq" />
        <CostSection data-id="element-15" data-mp="33ngdzzglelxc" />
        <SummaryTable data-id="element-16" data-mp="33myl9ct52pu6" />
        <FinalCta data-id="element-17" data-mp="38lrp0dimj2h5" />
      </main>
      <Footer data-id="element-18" data-mp="38li7zffk45nl" />
      <PurchaseNotification data-id="element-19" data-mp="38l03xwmnkn54" />
    </div>;
}